import React from 'react';
import cx from 'classnames';
var clsPrefix = 'tcpc-tag';

var Tag = function Tag(props) {
  var className = props.className,
      style = props.style,
      children = props.children,
      selected = props.selected,
      arrow = props.arrow,
      onClick = props.onClick;
  var baseProps = {
    style: style,
    className: cx(clsPrefix, className, {
      selected: selected
    })
  };
  return /*#__PURE__*/React.createElement("div", Object.assign({}, baseProps, {
    onClick: onClick
  }), children, arrow && /*#__PURE__*/React.createElement("i", {
    className: "".concat(clsPrefix, "-arrow")
  }));
};

Tag.defaultProps = {
  selected: false,
  arrow: false
};
export default /*#__PURE__*/React.memo(Tag);